<nav
  class="navbar navbar-expand-md"
  *ngIf="!!selectedCustomer"
  [ngClass]="{ 'navbar-ref': environment.projectName === 'ref' }"
>
  <button class="navbar-toggler btn" type="button" (click)="toggleMobileMenu()">
    <i class="fas fa-bars"></i>
  </button>
  <div class="collapse navbar-collapse" [ngClass]="baseCollapseClasses">
    <ul class="navbar-nav" *ngIf="authenticated">
      <li class="nav-item" ngbDropdown>
        <a class="nav-link text-primary" ngbDropdownToggle id="myPagesDropdown" role="button" translate
          >MY_PAGES <span>({{ selectedCustomer.name }})</span></a
        >
        <div ngbDropdownMenu aria-labelledby="myPagesDropdown" class="dropdown-menu">
          <a class="dropdown-item" routerLink="/customers/{{ selectedCustomer.id }}">
            <span translate>CUSTOMER_DETAILS</span>
          </a>
          <a class="dropdown-item" routerLink="/carts">
            <span translate>SAVED_CARTS</span>
          </a>
          <a class="dropdown-item" routerLink="/" (click)="logout()" translate>SIGN_OUT</a>
        </div>
      </li>
    </ul>
    <ul class="navbar-nav">
      <li class="nav-item" *ngIf="!authenticated">
        <a class="nav-link" routerLink="/" translate>SIGN_IN</a>
      </li>
    </ul>
  </div>
  <a class="navbar-brand" routerLink="/">
    <img [src]="logoSrc" width="auto" height="36px" alt="Logotype" />
  </a>
  <div *ngIf="!authenticated" class="">
    <lib-lang-select></lib-lang-select>
  </div>
  <div *ngIf="authenticated" class="">
    <ref-navbarcart [ngClass]="{ 'cart-button-white': environment.projectName === 'ref' }"></ref-navbarcart>
  </div>
</nav>
<div
  class="navbar-top-extra-menu bg-primary"
  *ngIf="extraLinks"
  [ngClass]="{ 'navbar-top-extra-menu-ref': environment.projectName === 'ref' }"
>
  <a
    *ngFor="let link of extraLinks"
    class="extra-menu-item"
    routerLinkActive="active"
    [routerLink]="link.route"
    (click)="link.action ? link.action() : undefined"
    translate
    >{{ link.heading }}</a
  >
</div>
